/* storybook-check-ignore */
import React from 'react';
import { css } from '@emotion/react';
import { media } from '@opendoor/bricks/theme/legacy/foundations/mediaBreakpoints';
import { Box, Flex } from '@opendoor/bricks/core';
import { Listing } from '../../declarations/exclusives/listing';
import { getFaqItems } from '../../helpers/exclusives/faq';
import HowPricingWorksPriceSection from './HowPricingWorksPriceSection';
import Accordion from './Accordion';

interface Props {
  listing: Listing;
  outsideOfModal?: boolean;
}

const accordionItems = getFaqItems([
  'why-can-i-buy-this-home-now-for-less-than-it-will-list-for',
  'why-wouldnt-i-just-wait-for-it-to-list',
  'what-if-the-home-appraises-for-less',
]);

const styles = {
  modalContainer: css`
    padding: 1rem 1.5rem 5rem;

    ${media.largerThan.MD} {
      padding: 0 3rem 3rem;
    }

    ${media.largerThan.LG} {
      padding: 3rem;
    }
  `,
};

const HowPricingWorks: React.FC<Props> = ({ outsideOfModal = false, listing }) => {
  return (
    <Box
      fontFamily="sans"
      borderRadius="semiRounded"
      css={!outsideOfModal && styles.modalContainer}
    >
      <Box mt="0.75rem" borderBottom="1px solid" borderColor="neutrals40">
        <Flex flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']} pb="1rem">
          <HowPricingWorksPriceSection listing={listing} isExclusive />
          <HowPricingWorksPriceSection listing={listing} />
        </Flex>
        <Accordion items={accordionItems} accordionName="howPricingWorksAccordion" noLeftPadding />
      </Box>
    </Box>
  );
};

export default HowPricingWorks;
